let questionTreeData = {};
// [questionId] = {campaigns: [{name:<>, id:<>}], locations: [{name:<>, id:<>}], assignments: [<treeNode>]}
//
export default questionTreeData;